import { MODEL_NAMES } from '../../../constants/index';
import { ROUTE_MAP } from '../../../services/messaging-navigation';
import { service } from '@ember/service';
import { setOwner } from '@ember/application';

export default class WebsocketActivityHandlersMessage {
  @service messaging;
  @service messagingNavigation;
  @service store;

  constructor(owner) {
    setOwner(this, owner);
  }

  handleActivity(response) {
    const statusHandlers = {
      created: this.#handleCreatedActivity,
      destroyed: this.#handleDestroyedActivity,
    };
    const handler = response.status ? statusHandlers[response.status] : null;

    if (!handler) {
      // TODO: Use Bugsnag for logging
      return;
    }

    handler.call(this, response.payload);
  }

  #handleCreatedActivity(payload) {
    const message = this.store.normalize(MODEL_NAMES.MESSAGE, payload.data);
    const {
      data: { attributes, relationships },
    } = message;
    const conversationId = relationships.conversation.data.id;

    let localRecord;
    if (attributes.localId) {
      localRecord = this.store
        .peekAll(MODEL_NAMES.MESSAGE)
        .find(record => record.localId === attributes.localId);
    }
    const isFromCurrentConversation =
      this.messagingNavigation.isCurrentRoute(ROUTE_MAP.conversation) &&
      this.messagingNavigation.currentRoute.handler.conversation.id === conversationId;
    const record = localRecord || this.store.push(message);

    if (isFromCurrentConversation && !this.#messageAlreadyPresent(record)) {
      this.messagingNavigation.currentRoute.handler.messages?.unshiftObject(record);
    }

    if (!attributes.isSystem) {
      this.#updateConversationLastMessage(conversationId, record);
      if (!attributes.isOwn) {
        this.#addUnreadConversation(conversationId);
      }
    }
  }

  #handleDestroyedActivity(payload) {
    this.store.pushPayload(MODEL_NAMES.MESSAGE, payload);
  }

  #messageAlreadyPresent(message) {
    return this.messagingNavigation.currentRoute.handler.messages?.content?.some(
      m => m.id === message.id || m.localId === message.localId
    );
  }

  #updateConversationLastMessage(conversationId, message) {
    const conversation = this.store.peekRecord(MODEL_NAMES.CONVERSATION, conversationId);
    conversation.updatedAt = new Date();
    conversation.lastMessage = message;
  }

  #addUnreadConversation(conversationId) {
    this.messaging.currentProfile.addUnreadConversation(conversationId);
  }
}
